<template>
  <div id="formulario-edit-info">
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vx-card>
        <div class="vx-row mb-4">
            <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                <vs-input class="w-full mt-4" :label="$t('TelaCategoriaPontoInteress_lNome')" v-model="data_local.nome" name="nome" />                
            </div>     
            <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full">
                <vs-input class="w-full mt-4" :label="$t('TelaCategoriaPontoInteress_lDescricao')" v-model="data_local.descricao" name="descricao" />                
            </div>     
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col lg:w-1/8 md:w-1/4 sm:w-1/2 w-full flex">
                <div>
                    <label class="vs-input--label" >{{$t('TelaCategoriaPontoInteress_lIcone')}}</label> 
                    <v-select                                           
                        :reduce="iconePontoInteresse => iconePontoInteresse.data" 
                        :options="listaIconesPontoInteresse" 
                        v-model="data_local.icone"     
                        style="height: 40px">
                        <template slot="option" slot-scope="option">
                            <img :src="`${publicPath}${option.fullImage}`">
                        </template>
                        <template #selected-option="{ fullImage }">
                            <img :src="`${publicPath}${fullImage}`" style="max-height:40px">
                        </template>
                    </v-select>  
                </div>
                <div class="mt-6 ml-2" >
                    
                    <v-swatches
                        v-bind:class="{ 'border': data_local.corEmHexa === '#ffffff', 'border-solid':  data_local.corEmHexa === '#ffffff' }"                                
                        v-model="data_local.corEmHexa"
                        popover-x="right"                    
                        show-fallback
                        fallback-input-type="color"   
                        v-on:close="atualizarCor"             
                    ></v-swatches>                 
                </div>
            </div>     
        </div>

        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">                    
                <vs-button class="ml-auto mt-2" size="small" @click="gravar" :disabled="!temPermissaoGravar && !temCapacidadeMaster" color="success">{{ $t('Btn_Gravar') }}</vs-button>
                <vs-button class="ml-4 mt-2" size="small" @click="excluir" :disabled="!temPermissaoGravar && !temCapacidadeMaster" v-show="isDeletable" color="danger">{{ $t('Btn_Excluir') }}</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>             
            </div>
        </div>
    </vx-card>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"

const URL_SERVLET = "/GruposPontoInteresseRestServlet";
const NAME_ROUTE_SEARCH = "frota-categoria-ponto-interesse";


import { CONSTANTE_ICONES_PONTO_INTERESSE } from '@/constantesImagens.js'

export default {    
  components: { VSwatches },  
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
            return {nome: '', CNPJCPF: null, endereco: null, telefones: null, emails: null, corEmHexa: '#FF0000'}
       }
    },
  },
  data() {
    return {
        errorsValidacao: [], 
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),
        publicPath: process.env.BASE_URL 
    }
  },  
  created() {
      this.listaIconesPontoInteresse = CONSTANTE_ICONES_PONTO_INTERESSE;
  } ,
  mounted() {
      
  },
  computed: {  
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },   
    validateForm() {
      return !this.errors.any()
    },
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }
  },
  methods: {   
    excluir() {
       const params = new URLSearchParams();        
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);

        if (this.data_local.hasOwnProperty("id")) {
          params.append('id', this.data_local.id);   
          params.append('method', 'Delete');      
        }  
                
        axios.post(URL_SERVLET, params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                // Efetuar logoff
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar Divisao");                        
            } else {
                /* eslint-disable no-console */  console.log(response.data);
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 

            const params = new URLSearchParams();        
            params.append('outputFormat', 'JSON');
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            
            if (this.data_local.hasOwnProperty("id")) {
                params.append('id', this.data_local.id);   
                params.append('method', 'Update');      
            }  else {
                params.append('method', 'Insert');      
            }  
            params.append('nome', this.data_local.nome);      
            params.append('descricao', this.data_local.descricao);      
            params.append('icone', this.data_local.icone);   
            params.append('corEmHexa', this.data_local.corEmHexa);   
                                   
            axios.post(URL_SERVLET, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {
                    if (response.data.hasOwnProperty("error")) {
                            this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                   
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.nome) {
            this.errorsValidacao.push(this.$t('TelaCategoriaPontoInteress_lNome') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

         if (!this.data_local.icone) {
            this.errorsValidacao.push(this.$t('TelaCategoriaPontoInteress_lIcone') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },         
  }
}
</script>